import React from 'react';
import PropTypes from 'prop-types';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { Link as RRRLink } from 'react-router-dom';
import VideoPlayer from '@bd/bdui-videoplayer';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import { BtnAnimationSheen } from '../../../helpers/UIElements';
import { colors } from '../../../styles';

const videoCSS = css`
  position: absolute;
  width: 100%;
  height: 100%;
  padding-top: 56.25%;
  top: 0;
  overflow: hidden;
  @media (min-width: 1600px) {
    padding: 50% 0 0 0;
    background-position: center bottom;
  }
  video {
    object-fit: cover;
  }
  /* IE Media Query */
  @media(min-width: 0\0) {
   video {
     position: absolute;
     top: 0;
     right: 0;
     bottom: 0;
     left: 0;
     object-fit: 'cover';
     min-width: 100%;
     min-height: 100%;
     width: auto !important;
     height: auto !important;
   }
  }
`;

const styles = css`
  padding: 25% 0 35% 0;
  position: relative;
  @media (min-width: 1600px) {
    padding: 50% 0 0 0;
  }
  &::after {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,.1);
    z-index: 1;
  }
  .HerosVideo_wrapper {
    padding: 0 20px;
    z-index: 10;
    padding: 20px;
    @media (min-width: 500px) {
      background-color: ${colors.color2};
    }
    @media (min-width: 992px) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 13% 0 0;
      background-color: transparent;
    }
  }
  .HeroVideo_h1 {
    font-weight: 300;
    font-size: 40px;
    color: #FFFFFF;
    text-shadow: 1px 1px 10px #000;
    letter-spacing: 1.31px;
    text-align: center;
    line-height: 60px;
    z-index: 1;
    @media(min-width: 768px) {
      font-size: 50px;
    }
    @media(min-width: 992px) {
      font-size: 71px;
      letter-spacing: 2.22px;
    }
  }
  .HeroImage_btnsWrapper {
    margin: 30px 0 0;
    display: flex;
    flex-direction: column;
    z-index: 2;
    @media(min-width: 992px) {
      flex-direction: row;
      margin: 40px 0 0;
    }
    li:last-child {
      margin: 15px 0 0;
      @media(min-width: 992px) {
        margin: 0 0 0 15px;
      }
    }
  }
  .HeroImage_btn {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(214, 155, 41, 0.65);
    min-width: 263px;
    transition: all .3s ease-out;
    @media(min-width: 992px) {
      min-width: 315px;
    }
    &:hover {
      @media(min-width: 768px) {
        background-color: rgba(214, 155, 41, 0.85);
        transform: scale(1.05);
      }
    }
    &::before {
      content: '';
      width: 116px;
      height: 3px;
      background-color: #7d5f26;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
    }
    &::after {
      z-index: -1;
    }
  }
  .HeroImage_btnLink {
    font-weight: 700;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    cursor: pointer;
    @media(min-width: 992px) {
      height: 68px;
      font-size: 19px;
    }
  }
`;

function HeroVideo({ content }) {
  return (
    <div
      className={styles}
      style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, 'images[0].contentUrl'), { width: 2000, height: 2000, preserve: true })})` }}
    >
      <VideoPlayer
        playing
        playsinline
        muted
        loop
        className={videoCSS}
        url={get(content, 'video.contentUrl')}
      />
      <hgroup className="HerosVideo_wrapper d-flex flex-column justify-content-center align-items-center">
        <h1 className="HeroVideo_h1">{get(content, 'title')}</h1>
        <ul className="d-md-flex list-unstyled HeroImage_btnsWrapper">
          {
            get(content, 'buttons').slice(0, 2).map(item => (
              <li key={item._id}>
                <BtnAnimationSheen className="HeroImage_btn">
                  <RRRLink to={get(item, 'button_url')} className="HeroImage_btnLink">
                    {get(item, 'button_text')}
                  </RRRLink>
                </BtnAnimationSheen>
              </li>
            ))
          }
        </ul>
      </hgroup>
    </div>
  );
}

HeroVideo.propTypes = {
  content: PropTypes.object.isRequired,
};

export default HeroVideo;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HeroSlider/HeroVideo.js